<template>
  <div class="billDetail">
    <h3>发票详情</h3>
    <div class="content">
      <ul>
        <li>
          <div class="top">
            <p>订单编号：{{billDetail.orderSn}}</p>
            <p>{{dealStatus(billDetail.status)}}</p>
          </div>
          <div class="middle">
            <p>发票抬头：个人</p>
            <p>发票金额：{{billDetail.money}}元</p>
            <p>发票内容：服务费</p>
            <p>收货地址：{{billDetail.express}}快递（收件人付）</p>
          </div>
          <div class="bottom">
            <p><span>{{billDetail.name}}</span><span>{{userBaseInfo.mobile}}</span></p>
            <p>{{billDetail.addressStr}}</p>
            <p>{{billDetail.remark}}</p>
            <p>订单编号：{{billDetail.orderSn}}</p>
            <p>申请时间：2017-09-12 13：50：56</p>
            <p>发货时间：2017-09-12 13：50：56</p>
            <p>收货时间：2017-09-12 13：50：56</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {reqInvoiceDetail} from '../../../api'
export default {
  data() {
    return {
      billDetail: {}
    }
  },
  created() {
    const {id} = this.$route.query
    reqInvoiceDetail(id).then(res => {
      if(res.code === 200) {
        this.billDetail = res.data.bussData
        let str = ''
        JSON.parse(res.data.bussData.address).forEach(item => {
          str += item
        })
        str += res.data.bussData.detaileAddress
        this.billDetail.addressStr = str
      }
    })
  },
  methods: {
    // 处理状态
    dealStatus (val) {
      switch (Number(val)) {
        case -1 :
          return '已取消'
        case 1 :
          return '受理中'
        case 2 :
          return '待收货'
        case 3 :
          return '已收货'
      }
    }
  },
  computed: {
    ...mapState(['userBaseInfo'])
  }
}
</script>

<style scoped lang="less" type="text/less">
  .billDetail{
    h3{
      margin-top:60px;
      font-size: 24px;
    }
    .content{
      width: 900px;
      margin-top:40px;
      padding:22px 20px 15px;
      box-sizing: border-box;
      box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
      border-radius:10px;
      ul{
        li{
          .top{
            display: flex;
            justify-content: space-between;
            padding-bottom: 20px;
            border-bottom:1px solid #e1e1e1;
            p{
              &:last-of-type{
                color:#E60012;
                font-size: 16px;
                font-weight: 500;
              }
            }
          }
          .middle{
            padding-bottom: 20px;
            border-bottom:1px solid #e1e1e1;
            p{
              margin-top:20px;
            }
          }
          .bottom{
            padding-bottom: 20px;
            p{
              margin-top:20px;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/BillDetail.vue